// Lazy-load PDF.js (and its worker) the first time a caller needs it, so it
// never weighs on the initial page load. Memoized for the life of the page.
let pdfjsPromise;

export function loadPdfjs() {
  if (!pdfjsPromise) {
    pdfjsPromise = (async () => {
      const pdfjs = await import("pdfjs-dist");
      const worker = await import("pdfjs-dist/build/pdf.worker.min.mjs?url");
      pdfjs.GlobalWorkerOptions.workerSrc = worker.default;
      return pdfjs;
    })();
    // A failed load (e.g. a chunk 404 mid-deploy) shouldn't poison later tries.
    pdfjsPromise.catch(() => {
      pdfjsPromise = undefined;
    });
  }
  return pdfjsPromise;
}
